import React from 'react';
import { Table } from 'reactstrap';

export const TsuCauseCodeModal = {
  title: 'Tsunami Cause Code',
  body: (
    <div>
      <div>
        Valid values:
        {' '}
        <b>0 to 11</b>
      </div>
      <br />
      <p>The source of the tsunami:</p>
      <Table size="sm">
        <tbody>
          <tr>
            <th scope="row">0</th>
            <td>Unknown</td>
          </tr>
          <tr>
            <th scope="row">1</th>
            <td>Earthquake</td>
          </tr>
          <tr>
            <th scope="row">2</th>
            <td>Questionable Earthquake</td>
          </tr>
          <tr>
            <th scope="row">3</th>
            <td>Earthquake and Landslide</td>
          </tr>
          <tr>
            <th scope="row">4</th>
            <td>Volcano and Earthquake</td>
          </tr>
          <tr>
            <th scope="row">5</th>
            <td>Volcano, Earthquake, and Landslide</td>
          </tr>
          <tr>
            <th scope="row">6</th>
            <td>Volcano</td>
          </tr>
          <tr>
            <th scope="row">7</th>
            <td>Volcano and Landslide</td>
          </tr>
          <tr>
            <th scope="row">8</th>
            <td>Landslide</td>
          </tr>
          <tr>
            <th scope="row">9</th>
            <td>Meteorological</td>
          </tr>
          <tr>
            <th scope="row">10</th>
            <td>Explosion</td>
          </tr>
          <tr>
            <th scope="row">11</th>
            <td>Astronomical Tide</td>
          </tr>
        </tbody>
      </Table>
    </div>
  ),
};
